import React from "react";
import "./footer.scss";

const Footer = () => {
  return (
    <footer className="site-footer">
      <a href="mailto:contact@bydru.com" className="footer-email">
        contact@bydru.com
      </a>
    </footer>
  );
};

export default Footer;
